import { Component, HostBinding, Input } from '@angular/core';
import { TenantConfigService } from '../../../../../../../tenant-config/tenant-config.service';

/**
 * Standalone page container whose content sits in a centered white card
 */
@Component({
  selector: 'hfc-standalone-modal-container',
  templateUrl: './standalone-modal-container.component.html',
  styleUrls: ['./standalone-modal-container.component.scss']
})
export class StandaloneModalContainerComponent {
  @Input() showCopyright = false;

  public currentYear: number = new Date().getFullYear();

  /** Client login background from the tenant config; consumed by the :host desktop rule in the scss. */
  @HostBinding('style.--client-login-bg')
  public get clientLoginBackgroundCss(): string {
    return `url('${this.tenantConfigService.clientLoginBackgroundUrl}')`;
  }

  constructor(public readonly tenantConfigService: TenantConfigService) {}
}
